import { DefaultState } from '@src/redux/types'

import * as TYPES from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [TYPES.DISTANCE_LEARNING_TIMETABLE]: DefaultState<`${typeof API.DISTANCE_LEARNING_TIMETABLE}`, 'get'>
  // [TYPES.DISTANCE_LEARNING_TIMETABLE_UPDATED]: DefaultState<`${typeof API.DISTANCE_LEARNING_TIMETABLE_UPDATED}`, 'get'>
  [TYPES.DISTANCE_LEARNING_TIMETABLE_ALL]: DefaultState<`${typeof API.DISTANCE_LEARNING_TIMETABLE_ALL}`, 'get'>
  // [TYPES.DISTANCE_LEARNING_TIMETABLE_GENERATE]: DefaultState<`${typeof API.DISTANCE_LEARNING_TIMETABLE_GENERATE}`, 'post'>
} = () => ({
  [TYPES.DISTANCE_LEARNING_TIMETABLE]: defaultState(),
  // [TYPES.DISTANCE_LEARNING_TIMETABLE_UPDATED]: defaultState(),
  [TYPES.DISTANCE_LEARNING_TIMETABLE_ALL]: defaultState(),
  // [TYPES.DISTANCE_LEARNING_TIMETABLE_GENERATE]: defaultState(),
})
